<template>
  <div v-if="visible">
    <!-- Takes the banner's height at the end of the page, so it never covers the form -->
    <div :style="{ height: `${height}px` }"></div>
    <div ref="banner" class="cookie-banner" role="region" aria-label="Cookie consent">
      <p class="cookie-text">
        We use cookies to understand how our booking page is used and to improve it. See our
        <a :href="privacyUrl" target="_blank" rel="noopener">privacy policy</a>.
      </p>
      <div class="cookie-actions">
        <button type="button" class="cookie-btn" @click="choose('all')">Accept all</button>
        <button type="button" class="cookie-btn" @click="choose('necessary')">Necessary only</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getConsentChoice, setConsent } from "@/utils/adConsent";
import { hostMarket } from "@/utils/tracking";

// UK booking subdomain only. Without a choice, UK consent stays "denied" and
// GTM never loads Clarity, Contentsquare or the Meta pixel.
export default {
  name: "CookieBanner",
  data: () => ({
    visible: hostMarket() === "UK" && getConsentChoice() === null,
    height: 0,
    privacyUrl: "https://www.tapestodigital.co.uk/privacy-policy",
  }),
  mounted() {
    if (!this.visible) return;
    this.measure();
    window.addEventListener("resize", this.measure);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.measure);
  },
  methods: {
    measure() {
      if (this.$refs.banner) this.height = this.$refs.banner.offsetHeight;
    },
    choose(choice) {
      setConsent(choice);
      this.visible = false;
      window.removeEventListener("resize", this.measure);
    },
  },
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px 20px;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));
  background: #fff;
  border-top: 1px solid #dfe5e4;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.08);
}

.cookie-text {
  font-size: 0.8rem;
  color: #1e2a28;
  margin: 0;
  max-width: 560px;
}

.cookie-text a {
  color: #2f6f6b;
  text-decoration: underline;
}

.cookie-actions {
  display: flex;
  gap: 10px;
}

/* Equal size and weight: neither choice is nudged */
.cookie-btn {
  min-width: 140px;
  padding: 8px 14px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #2f6f6b;
  background: #fff;
  border: 1px solid #2f6f6b;
  border-radius: 4px;
}

.cookie-btn:hover {
  background: #eef5f4;
}

@media (max-width: 600px) {
  .cookie-actions {
    width: 100%;
  }

  .cookie-btn {
    flex: 1 1 0;
    min-width: 0;
  }
}
</style>
